import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DisplayErrorsService {
  @Output() onError: EventEmitter<any> = new EventEmitter();
}
